/*
 * @Author: LHB
 * @Date: 2022-06-08 21:06:01
 * @LastEditTime: 2022-06-17 21:26:10
 * @LastEditors: LHB
 * @Description:
 * @FilePath: \shirleyClass\src\utils\tools.js
 * ---
 */

import vm from '../main'
import jsmd5 from 'js-md5'
// const md5Fn = require('md5')

// 获取url参数
function getQueryString(url, name) {
  var reg = new RegExp('(^|&?)' + name + '=([^&]*)(&|$)', 'i')
  var r = url.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

function showLoading(text, duration) {
  vm.$toast.loading({
    message: text || '加载中...',
    forbidClick: true,
    duration: duration || 0,
    overlay: true
  })
}
function hideLoading() {
  let timer = setTimeout(() => {
    vm.$toast.clear()
    clearTimeout(timer)
  }, 1000)
}

function md5(message) {
  // return md5Fn(message)
  console.log('新的jsmd5', jsmd5(message))
  return jsmd5(message)
}
export default {
  getQueryString,
  showLoading,
  hideLoading,
  md5
}
